import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICardResponse } from '../models/cards.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Get an individual card
 * 
 * @returns {object} the api response
 */
const GetCardIndividual = async (cardNumber: string): Promise<ICardResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/cards/${cardNumber}`, {
      params: {
        wpID: userId,
        cardNumber: +cardNumber
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting card');
    throw(error)
  }
}

export default GetCardIndividual;